<template>
  <div class="d-flex flex-column justify-center align-center">
    <v-progress-circular
      indeterminate
      color="primary"
      class="mb-3"
      :size="50"
    />
    <p class="overline text--disabled">
      {{ $t(textLoader) }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'LoaderSpinner',
  props: {
    size: {
      default: '40px',
    },
    textLoader: {
      default: 'common.loading',
    },
  },
  computed: {
    styles() {
      return {
        width: this.size,
        height: this.size,
      }
    },
  },
}
</script>
